import React from 'react'
import { Modal } from 'react-bootstrap'

function DetailedViewCollectOrder({ data, close, showDetailedView }: { data: any, close: () => void, showDetailedView: boolean }) {
    console.log("data", data)
    return (
        <Modal
            show={showDetailedView}
            onHide={close}
            backdrop={false}
            centered
            size='lg'
            className='modal fade'
            id='kt_modal_new_address'
        >
            <div className='modal-header'>
                <h3 className='fw-bolder fs-3'>Order details</h3>
                <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    data-kt-users-modal-action='close'
                    onClick={close}
                    style={{ cursor: 'pointer' }}
                >
                    <i className='ki-duotone ki-cross fs-1'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                    </i>
                </div>
            </div>
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead>
                            <tr className='fw-bolder text-dark'>
                                <th>Category name</th>
                                <th>Item name</th>
                                <th>Quantity (kg)</th>
                                <th>Unit price (IDR)</th>
                                <th>Order value (IDR)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.orderDetails?.map((category: any, catIndex: number) => (
                                category.items?.map((item: any, itemIndex: number) => (
                                    <tr key={`${catIndex}-${itemIndex}`}>
                                        <td>{category.categoryName}</td>
                                        <td className='d-flex align-items-center'>
                                            {item?.itemIcon && (
                                                <img src={item.itemIcon} alt='' style={{ width: '25px', height: '25px', objectFit: 'cover' }} className='rounded-circle me-3' />
                                            )}
                                            <span>{item.itemName}</span>
                                        </td>
                                        <td>{item.quantity}</td>
                                        <td>{item.price}</td>
                                        <td>{item.price * item.quantity}</td>
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    )
}

export default DetailedViewCollectOrder